import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { CUSTOMER_BILLING_CONFIGURATION_FRAGMENT } from './schema';

const QUERY = gql`
  query CustomerQueryQuota($id: ID!) {
    customer(id: $id) {
      id
      lifecycle
      billingConfiguration {
        ...CustomerBillingConfiguration
      }
    }
  }
  ${CUSTOMER_BILLING_CONFIGURATION_FRAGMENT}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'id' | 'lifecycle' | 'billingConfiguration'>;

export const queryCustomerBillingConfig = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
